var $0b5fc13def2a30c7$exports = {};
$0b5fc13def2a30c7$exports = {
    "Clear search": `Clear search`
};


export {$0b5fc13def2a30c7$exports as default};
//# sourceMappingURL=en-US.mjs.map
